import {Question} from 'shared/models/questions/question';
import {Tiplist} from 'shared/models/tips/tiplist';
import { DataSet } from 'vis-data/peer';
import { IdType, NodeOptions } from 'vis-network/peer';
import { Jump } from './jump';

export type Data = Question | Tiplist | Jump;

export interface Node extends NodeOptions {
  data?: Data;
  id?: IdType;
}

export type Callback = (nodeData: NodeOptions) => void;

export class Tools {
  public static isQuestion(nodeData: Data): nodeData is Question {
    return (<Question> nodeData).type !== undefined && (<Tiplist> nodeData).tips === undefined && (<Jump> nodeData).dataType !== 'jump';
  }

  public static isTiplist(nodeData: Data): nodeData is Tiplist {
    return (<Tiplist> nodeData).tips !== undefined && (<Jump> nodeData).dataType !== 'jump';
  }

  public static isJump(nodeData: Data): nodeData is Jump {
    return (<Jump> nodeData).dataType === 'jump';
  }
}

export interface SelectedElements {
  nodes: Array<IdType>;
  edges: Array<IdType>;
}

export interface ClickEvent extends SelectedElements {
  event: Event;
  pointer: {
    DOM: {x: number, y: number},
    canvas: {x: number, y: number},
  };
}

export type SelectEvent = ClickEvent;
export type Set = DataSet<Node>;



// WEBPACK FOOTER //
// /usr/src/app/src/app/modules/dynamic-tips/tree-view/interfaces/node.ts